interface ArticleViewProps {
  content: string
  className?: string
}

/**
 * ArticleView component for rendering HTML content in article-style layout.
 * Used for view_mode === "view" to display notes as read-only articles.
 *
 * Features:
 * - Styled container with proper typography (prose classes)
 * - Responsive images and code blocks
 * - Read-only display
 */
export default function ArticleView({ content, className = '' }: ArticleViewProps) {
  // If no content, show placeholder
  if (!content || content.trim() === '') {
    return (
      <div className={`prose prose-lg max-w-none p-6 sm:p-8 ${className}`}>
        <p className="text-gray-400 italic">No content</p>
      </div>
    )
  }

  return (
    <article
      className={`prose prose-lg max-w-none p-6 sm:p-8 ${className}`}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}
